// extracted by mini-css-extract-plugin
export default {"wrapper":"yXvMb8b7T_HAHj80EC8S","editButton":"I0vvEE9PXMzuOcKGK4nv"};